import React from 'react';
import PreparationTimeContainer from './PreparationTimeContainer';
import DashboardLayout from '../../../components/Shop/StoreLayout/Layout/DashboardLayout';
import messages from '../../../locale/messages';

function action({ store, params, intl }) {
    const title = intl.formatMessage(messages.preparationTime);

    let isStoreAuthenticated = store.getState().runtime.isStoreAuthenticated;

    if (!isStoreAuthenticated) {
        return { redirect: '/store/login' };
    };

    return {
        title,
        component: (
            <DashboardLayout>
                <PreparationTimeContainer title={title} />
            </DashboardLayout>
        )
    }
}

export default action;